import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";

import Header from "../headers/light.js";

import { ReactComponent as SvgDecoratorBlob1 } from "../../images/svg-decorator-blob-1.svg";
import DesignIllustration from "../../images/design-illustration-2.svg";
import CustomersLogoStripImage from "../../images/customers-logo-strip.png";
import ContactUsForm from "components/forms/SimpleContactUs.js";
import PrintServiceImage from "../../images/printpage/print-services.png";
const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col lg:flex-row lg:items-center max-w-screen-xl mx-auto py-5 md:py-5`;
const LeftColumn = tw.div`relative lg:w-6/12 text-center max-w-lg mx-auto lg:max-w-none lg:text-left`;
const RightColumn = tw.div`relative mt-12 lg:mt-0 flex-1 flex flex-col justify-center lg:self-end`;

const Heading = tw.h1`font-bold text-3xl md:text-3xl lg:text-4xl xl:text-5xl text-gray-900 leading-tight`;
const Subheading = tw.h5`text-xl md:text-xl lg:text-xl xl:text-xl text-gray-900 leading-tight font-semibold mt-4`;
const Paragraph = tw.p`my-5 lg:my-8 text-base xl:text-lg text-justify`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-6/12 lg:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-cover bg-center h-full`,
]);

const Actions = styled.div`
  ${tw`relative max-w-md text-center mx-auto lg:mx-0`}
  input {
    ${tw`sm:pr-48 pl-8 py-4 sm:py-5 rounded-full border-2 w-full font-medium focus:outline-none transition duration-300  focus:border-primary-500 hover:border-gray-500`}
  }
  button {
    ${tw`w-full sm:absolute right-0 top-0 bottom-0 bg-primary-500 text-gray-100 font-bold mr-2 my-4 sm:my-2 rounded-full py-4 flex items-center justify-center sm:w-40 sm:leading-none focus:outline-none hover:bg-primary-900 transition duration-300`}
  }
`;

const IllustrationContainer = tw.div`flex justify-center lg:justify-end items-center`;

// Random Decorator Blobs (shapes that you see in background)
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none opacity-5 absolute left-0 bottom-0 h-64 w-64 transform -translate-x-2/3 -z-10`}
`;

const CustomersLogoStrip = styled.div`
  ${tw`mt-12 lg:mt-20`}
  p {
    ${tw`uppercase text-sm lg:text-xs tracking-wider font-bold text-gray-500`}
  }
  img {
    ${tw`mt-4 w-full lg:pr-16 xl:pr-32 opacity-50`}
  }
`;

export default ({ roundedHeaderButton }) => {
  return (
    <>
      {/* <Header roundedHeaderButton={roundedHeaderButton} /> */}
      <Container>
        <TwoColumn>
          <LeftColumn>
            <Heading>
              <span tw="text-primary-500"> Flexible Formats for a Customized Approach.</span>
            </Heading>
            <Paragraph>
              At Vizual Ads, we offer end-to-end printing solutions that adapt to your brand’s vision—across paper, fabric, merchandise, and large-format displays. From concept to final output, every print is crafted with precision, quality, and consistency.
            </Paragraph>
            <img src={PrintServiceImage} alt="Print Service" />

            {/* <Heading>
              <span> What We Print.</span>
            </Heading> */}
            {/* <Subheading>📄 Commercial & Marketing Printing </Subheading>
            <ul tw="list-disc list-inside text-justify">
              <li>Flyers, brochures, trifolds & catalogs</li>
              <li>Business cards, letterheads & stationery</li>
              <li>Posters, postcards & marketing collateral</li>
            </ul>
            <Subheading tw="mt-6">🖼️ Large Format & Display Printing </Subheading>
            <ul tw="list-disc list-inside text-justify">
              <li>Vinyl banners & flex prints</li>
              <li>A-frame boards & standees</li>
              <li>Event signage & promotional displays</li>
              <li>Window graphics & wall visuals</li>

            </ul>
            <Subheading tw="mt-6">👕Fabric & Merchandise Printing   </Subheading>
            <ul tw="list-disc list-inside text-justify">
              <li>Custom T-shirts & Hoodies</li>
              <li>Branded apparel & uniforms</li>
              <li>Promotional merchandise</li>
              <li>Sportswear & event wear</li>
            </ul>
            <Paragraph><strong tw="text-primary-500">DTF Printing:</strong> Bold colors, durability, and versatility on all fabrics<br />
              <strong tw="text-primary-500">Sublimation Printing:</strong> Seamless prints with vibrant, long-lasting finishes</Paragraph> */}
          </LeftColumn>
          <RightColumn>
            <ContactUsForm />
          </RightColumn>
        </TwoColumn>
        <DecoratorBlob1 />
      </Container>
    </>
  );
};
